export default {
  '跳首页': {
    name: 'jump_router',
    scene: '/home'
  },
  '跳登录页': {
    name: 'login_out'
  },
  '打开webview': {
    name: 'jump_router',
    scene: '/webview',
    paramsDemo: {
      'url': 'https://www.baidu.com', // 需要跳转的url
      'type': 'loan_market', // 贷超进入，需要返回弹出推荐框
      'title': '', // 界面标题
      'productId': '' // 产品id
    }
  },
  // 打开人脸、ocr
  '打开原生': {
    name: 'jump_router'
    // 'url': '/liveness?extraParams=xxx&next=home|close' // liveness人脸
    // 'url': '/ocr?type=app_home&next=home|close', // ocr实名
  },
  '退出登录': {
    name: 'login_out'
  },
  '关闭webview': {
    name: 'close_webview'
  },
  '返回拦截': {
    name: 'intercept_back',
    callback: 'nativeGoBack',
    paramsDemo: {
      'callback': 'nativeGoBack', // 执行
      'url': location.href,
      'isRecord': 0, // 0否 ；1是需要埋点记录；2埋点并且返回，（iOS：226；Android：130）(字段要传)
      'recordPara': { pageName: 'H5-xx', pageId: 'xx' } // （iOS：226；Android：130）
    }
  },
  /* '获取通讯录': {
    name: 'get_address_book',
    callback: 'nativeAddressBook',
    demo: {
      'isPower': '0', // 0没授权，1已授权
      'addressList': '张三:13200001111,李四:13311110000' // 通讯录数据
    }
  }, */
  '获取紧急联系人': {
    name: 'get_emergency_contact',
    callback: 'nativeGetEmergencyContact',
    demo: {
      'isPower': '0', // 0没授权，1已授权
      'EmergencyContact': { // 紧急联系人数据
        'name': '张三',
        'phone': '13200001111'
      },
      'addressList': '张三:13200001111,李四:13311110000' // 通讯录数据
    }
  },
  '打开分享弹窗': {
    name: 'app_share',
    scene: '/app_share',
    callback: 'nativeGetShareData',
    paramsDemo: {
      'shareUrl': '分享链接',
      'title': '标题',
      'content': '内容',
      'iconUrl': 'logo地址',
      'appLogin': '1 需要登录 0 不需要登录'
    },
    demo: {
      type: '1' // 是否分享成功：1成功，0失败
    }
  },
  '获取地理位置': {
    name: 'get_location',
    callback: 'nativeGetLocationData',
    demo: {
      'isPower': '0', // 是否授权：1授权，0为授权
      'isSet': '0', // 0取消，1去设置
      // 'isSet': '0', // 0取消，1去设置
      'gpsMap': {
        'addressComponent': {
          'province': '浙江省',
          'city': '杭州市',
          'district': '萧山区'
        },
        'formattedAddress': '浙江省杭州市萧山区宁围街道金二路',
        'position': {
          'lng': 120.255849, // 经度
          'lat': 30.198129 // 纬度
        }
      }
    }
  },
  '地理位置授权': {
    name: 'get_location_status',
    callback: 'nativeGetLocationStatus',
    demo: {
      'isPower': '0', // 是否授权：1授权，0为授权
      'gpsMap': {
        'addressComponent': {
          'province': '浙江省',
          'city': '杭州市',
          'district': '萧山区'
        },
        'formattedAddress': '浙江省杭州市萧山区宁围街道金二路',
        'position': {
          'lng': 120.255849, // 经度
          'lat': 30.198129 // 纬度
        }
      }
    }
  },
  '保存图片': {
    name: 'save_img',
    scene: '/save_img',
    paramsDemo: {
      'imgUrl': 'https://www.baidu.com', // 图片文件地址
      'openUrl': 'https://www.baidu.com/，/home，weixin://，linziapp://easyloan' // 是否打开url：https相关url，app内部路 由，外部三方路由
    }
  },
  '签到提醒': {
    name: 'signin_remind',
    scene: '/signin_remind',
    paramsDemo: {
      'type': '1' // 1签到提醒，2开启通知权限
    },
    demo: {
      'isPower': '1', // 是否授权：1授权，0为授权
      'type': '1' // 1签到提醒，2开启通知权限
    }
  },
  /* '获取通话记录': {
    name: 'get_call_record',
    callback: 'nativeCallRecord',
    demo: {
      'isPower': '1',
      'CallLogList': '张三:13200001111,李四:13311110000'
    }
  }, */
  /* '获取appList': {
    name: 'get_app_list',
    callback: 'nativeAppList',
    demo: {
      'appList': '淘宝,钉钉'
    }
  }, */
  '获取电话识别码': {
    name: 'get_device_id',
    callback: 'nativeDeviceId',
    demo: {
      'deviceId': 'xxxx'
    }
  },
  '获取环境参数': {
    name: 'get_environment',
    callback: 'nativeGetEnvironmentParams',
    demo: {
      envParams: 'xxx'
    }
  },
  '通知客户端': {
    name: 'post_trigger',
    scene: '/post_trigger',
    paramsDemo: {
      tiggerData: '1',
      nonce: 'xxx'
    }
  }
}
